export const pmaPayment = (instance, data) => {
  return instance()
    .post(`/pma/api/v1/payment/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const pmaSubmitReceipt = (instance, trxUuid) => {
  return instance()
    .post(`/pma/api/v1/submit/receipt/${trxUuid}/`)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};

export const paymentReviewReceipt = (instance, data) => {
  return instance()
    .post(`/pma/api/v1/review/receipt/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};
